export default __webpack_public_path__ + "media/images/missing-dcb52c708b450d466f65109bbdc1869c.png";